namespace Solovis.Reports.DataPacks {

    export class DataPackSelector {

        private static DefaultMountCodeKey = "solovis.reports.defaultMountCode";
        public static LiveDatabaseCode = "***live-database***";

        private static _selectorDialog;


        public static getDefaultMountCode() {
            let sessionValue = window.sessionStorage.getItem(DataPackSelector.DefaultMountCodeKey);
            if (Solovis.isNotNull(sessionValue)) {
                if (sessionValue === DataPackSelector.LiveDatabaseCode) {
                    return null;
                }
                else {
                    return sessionValue;
                }
            }
            else {
                let storageValue = window.localStorage.getItem(DataPackSelector.DefaultMountCodeKey);
                if (Solovis.isNotNull(storageValue)) {
                    if (storageValue === DataPackSelector.LiveDatabaseCode) {
                        return null;
                    }
                    else {
                        return storageValue;
                    }
                }
                else {
                    return null;
                }
            }
        }

        public static setDefaultMountCodeForSession(defaultMountCode) {
            if (Solovis.isNotNull(defaultMountCode)) {
                window.sessionStorage.setItem(DataPackSelector.DefaultMountCodeKey, defaultMountCode);
            }
            else {
                window.sessionStorage.setItem(DataPackSelector.DefaultMountCodeKey, DataPackSelector.LiveDatabaseCode);
            }

            this._notifyNewDataPackSelected();
        }

        public static setDefaultMountCodeForLocalBrowser(defaultMountCode) {
            if (Solovis.isNotNull(defaultMountCode) && defaultMountCode !== DataPackSelector.LiveDatabaseCode) {
                window.localStorage.setItem(DataPackSelector.DefaultMountCodeKey, defaultMountCode);

                // Ensure a session value doesn't mask this new setting.
                window.sessionStorage.removeItem(DataPackSelector.DefaultMountCodeKey);
            }
            else {
                window.localStorage.removeItem(DataPackSelector.DefaultMountCodeKey);

                // Ensure a session value doesn't mask this new setting.
                window.sessionStorage.removeItem(DataPackSelector.DefaultMountCodeKey);
            }

            this._notifyNewDataPackSelected();
        }


        public static showDataPackSelectorDialog() {

            if (!DataPackSelector._selectorDialog) {
                DataPackSelector._selectorDialog = new DataPackSelectorDialog();
            }
            
            DataPackSelector._selectorDialog.show();
        }


        private static _notifyNewDataPackSelected() {
            $(DataPackSelector).trigger("dataPackSelected");
        }
    }

}